<template>
    <div style="z-index: 999999">
        <div class="modal hide fade" id="modalInventoryListApprove" tabindex="0" role="dialog" aria-labelledby="modalInventoryListApprove" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Inventory Approve List</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-sm table-item table-hover table-striped">
                                        <thead>
                                            <th>
                                                <label class="form-checkbox"><input type="checkbox" v-model="selectAll" @click="select"><i class="form-icon"></i></label>
                                            </th>
                                            <th>Status</th>
                                            <th>Inventory No</th>
                                            <th>Ext No.</th>
                                            <th>Date</th>
                                            <th>Vendor</th>
                                        </thead>
                                        <tbody>
                                            <tr v-if="filterData.length < 1">
                                                <td colspan="6" style="text-align: center;"><i>No Data</i></td>
                                            </tr>
                                            <tr v-for="d in filterData" :key="d.id">
                                                <td>
                                                    <label class="form-checkbox">
                                                        <input type="checkbox" :value="d.id" v-model="selected"><i class="form-icon"></i>
                                                    </label>
                                                </td>
                                                <td>
                                                    <span class="badge badge-success" v-if="d.status === 'approved'">{{ d.status }}</span>
                                                    <span class="badge badge-warning" v-else>{{ d.status }}</span>
                                                </td>
                                                <td>{{ d.inventory_no }}</td>
                                                <td>{{ d.ext_no }}</td>
                                                <td>{{ d.inventory_date }}</td>
                                                <td>{{ d.vendor }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!-- <pre>{{ vendorNo }}</pre>
                        <pre>{{ inventoryApproveList }}</pre> -->
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-sm btn-soft-primary" data-dismiss="modal" aria-label="Close" @click="process">Process</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'InventoryListApproveModal',
  props: ['vendorNo'],
  computed: {
    ...mapState({
      inventoryApproveList: state => state.inventories.inventoryApproveList
    }),
    filterData () {
      var array = [{
        id: null,
        inventory_no: null,
        inventory_date: null,
        notes: null,
        purchasing_no: null,
        warehouse_no: null,
        wareshouse: null,
        status: null,
        ext_no: null,
        branch_no: null,
        user_id: null,
        user_approve: null,
        lock: false,
        type_id: null,
        company_no: null,
        company: null,
        ext_no2: null,
        vendor_no: null,
        vendor: null
      }]
      if (this.vendorNo !== null) {
        array = this.inventoryApproveList.filter(d => d.vendor_no === this.vendorNo)
      }
      return array
    }
  },
  data () {
    return {
      selected: [],
      selectAll: false,
      idDetail: 1,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      }
    }
  },
  methods: {
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    process () {
      console.log(this.selected)
      var array = this.selected
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = this.inventoryApproveList.find(d => d.id === array[i])
        console.log(obj)
        loop.push(obj)
      }
      this.$emit('selectInventoryAll', loop)
    }
  }
}
</script>
